import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=525f5b75&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=js&"
export * from "./NoData.vue?vue&type=script&lang=js&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=525f5b75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f5b75",
  null
  
)

export default component.exports